module.exports = __webpack_public_path__ + "static/media/fruits_6.0e540532.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_6.csv
// module id = 722
// module chunks = 0